export default [
  {
    path: '/modules/report',
    component: () => import('@/views/modules/report/Report.vue'),
    meta: {
      action: 'ROLE_RELATORIO_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatórios',
      breadcrumb: [
        {
          text: 'protocol',
        },
      ],
    },
    children: [
      {
        path: 'protocol',
        name: 'reportPageProtocol',
        component: () => import('@/views/modules/report/Report.vue'),
        meta: {
          pageTitle: 'Relatórios',
          action: 'ROLE_RELATORIO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Protocolo | Relatórios',
            },
          ],
        },
      },
    ],
  },
]
